import React from 'react'
import { Observable } from 'rxjs'
import { AjaxResponse } from 'rxjs/ajax'
import { getCashFlowReport } from 'utils/api-routes-accounts'
import ReportTablePage from './ReportTablePage'
import { useFinanceObservable } from '../../hooks/useFinanceObservable'

import { FinanceApiResponse } from '../../types/finance'

const CashFlow = () => {
  const report = useFinanceObservable<Record<string, any>[]>(
    () =>
      getCashFlowReport({}) as any as Observable<
        AjaxResponse<FinanceApiResponse<Record<string, any>[]>>
      >,
  )

  return (
    <ReportTablePage
      title="Cash Flow"
      rows={report.data || []}
      isLoading={report.loading}
      columns={[
        { name: 'Month', selector: (row) => (row.month as string) || '--' },
        { name: 'Inflow', selector: (row) => (row.inflow as number) || 0 },
        { name: 'Outflow', selector: (row) => (row.outflow as number) || 0 },
        {
          name: 'Net Change',
          selector: (row) => (row.net_change as number) || 0,
        },
      ]}
    />
  )
}

export default CashFlow
